import EnterPop from "@/components/Popups/EnterPop";
import NewFeature from "@/components/Popups/NewFeature";

/**
 * The main idea is to manage the initial popup
 * for the website from one place.
 *
 * @param {boolean} isNewFeature
 * @returns an object with all necessary properties
 * to the popup.
 * @argument key for local storage
 * @argument popup as a vue component
 * @argument args object with other arguments the popup might need.
 */
export function getInitPopup(isNewFeature = false, key = "after-login") {
  if (!isNewFeature) {
    return {
      key,
      popup: EnterPop
      // args: { step: "after-login" }
    };
  }

  return {
    key,
    popup: NewFeature,
    args: {
      title: "רופא/ה יקר/ה",
      content: `ממשק ניהול המרפאה התעדכן.
אנו מזמינים אותך לבצע פעולות עצמאיות במהירות ובקלות, ללא צורך בצוות ביה"ח, בהתאם לבחירתך.`,
      buttonText: "הבנתי"
    }
  };
}

export function getSurgeryErrorPopup() {
  return {
    popup: NewFeature,
    args: {
      title: "רופא/ה יקר/ה",
      content: `בוצע חיוב ונפתח תיק מטופל. לא ניתן לשבץ מחדש את הניתוח לעזרה יש ליצור קשר עם מוקד חדר ניתוח.`,
      buttonText: "סגור"
    }
  };
}
